import { style, transition, animate, state, trigger, useAnimation, animation } from '@angular/animations';

export const AdSlideUpDownAnimation:string = 'slideUpDown';

export function slideUpDownAnimationFunc(openState, closeState) {
  return trigger(AdSlideUpDownAnimation, [
    state(openState, style({ height: '*', opacity: 1, overflow: 'hidden' })),
    state(closeState, style({ height: 0, opacity: 0, padding: 0, overflow: 'hidden' })),
    transition(`${openState} => ${closeState}`, [
      animate('0.2s')
    ]),
    transition(`${closeState} => ${openState}`, [
      animate('0.2s')
    ]),
  ])
}
export function slideUpDownAnimation(aniName = 'slideUpDown') {
  return trigger(aniName, [
    state('in', style({ height: '', opacity: 1 })),
    transition('void => *', [
      style({ height: '0px', opacity: 0 }),
      animate(100)
    ]),
    transition('* => void', [
      animate(100, style({ height: '0px', opacity: 0 }))
    ])
  ])
}

export function EnterAnimation(){
  return [
    transition(':enter',useAnimation(
      animation([
        style({transform:'scale(0.8)',opacity:0}),
        animate('300ms ease-out',style({transform:'none',opacity:1}))
      ])
    ))
  ]
}
